<script setup>
import {computed, onMounted, ref} from "vue";
import {jwtDecode} from "jwt-decode";
import {useRoute} from "vue-router";
import Breadcrumbs from "../Breadcrumbs.vue";
import {isAuthenticated} from "@/utils/auth";
import store from "../../store";

const route = useRoute();
const userData = ref({});

const currentRouteName = computed(() => {
  return route.name;
});
const currentDirectory = computed(() => {
  let dir = route.path.split("/")[1];
  return dir.charAt(0).toUpperCase() + dir.slice(1);
});
const userEmail = ref("");
defineProps({
  msg: String,
  age:Number,
});
const goToLogin = () => {
  localStorage.clear();
}
const minimizeSidebar = () => store.commit("sidebarMinimize");
onMounted(() => {
  if(isAuthenticated()) {
    const token = localStorage.getItem("accessToken");
    if (token) {
      try {
        userData.value = jwtDecode(token);
        userEmail.value = userData.value.email;
      } catch (err) {
        console.error("Token không hợp lệ:", err.message);
      }
    }
  }

});
</script>
<template>
  <nav class="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl"
    v-bind="$attrs" id="navbarBlur" data-scroll="true">
    <div class="px-3 py-1 container-fluid">
      <breadcrumbs :current-page="currentRouteName" :current-directory="currentDirectory" />

      <div class="mt-2 collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4"
        id="navbar">
        <div class="pe-md-3 d-flex align-items-center ms-md-auto">

        </div>
        <ul class="navbar-nav justify-content-end">
          <li class="nav-item d-flex align-items-center">
            <router-link :to="{ name: 'Signin' }" @click="goToLogin" class="px-0 nav-link font-weight-bold text-white">
              <i class="fa fa-user me-sm-2"></i>
              <span class="d-sm-inline d-none">
                {{ userEmail ? userEmail : "Sign In" }}
              </span>
            </router-link>
          </li>
          <li class="nav-item d-xl-none ps-3 d-flex align-items-center">
            <a
                href="#"
                @click="minimizeSidebar"
                class="p-0 nav-link text-white"
                id="iconNavbarSidenav"
            >
              <div class="sidenav-toggler-inner">
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
                <i class="sidenav-toggler-line bg-white"></i>
              </div>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
